import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b919abc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "log" }
const _hoisted_2 = { class: "content-area" }
const _hoisted_3 = { class: "time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item) => {
        return (_openBlock(), _createElementBlock("p", {
          key: item.logId
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(item.createTime) + ":  ", 1 /* TEXT */),
          _createElementVNode("span", {
            class: _normalizeClass($setup.logColor(item.logType))
          }, _toDisplayString(item.logContent), 3 /* TEXT, CLASS */)
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createCommentVNode("分页"),
    _createVNode($setup["tablePager"], {
      ref: "pager",
      onPageChange: $setup.load_table,
      count: $setup.count
    }, null, 8 /* PROPS */, ["count"])
  ]))
}